import classNames from 'classnames';
import { CellRenderType, ComponentTester } from './renderCell.js';

export const RenderPrimitive: ComponentTester<CellRenderType.renderString> = ({ data, classes }) => {
  const el = <small className={classNames('u-block ', classes, data?.classes)}>{data?.dataSet}</small>;
  return el;
};

export const RenderPrimitiveBold: ComponentTester<CellRenderType.stringBold> = ({ data, classes }) => (
  <RenderPrimitive data={data} classes={classNames('u-textSemibold', classes)} />
);
